import { REDUCERS } from '../../constants/reducers';

import { TABLE_SIZE } from '../../components/AppTable/constants';

const initialState = {
  loading: true,
  isAdmin: false,
  user: {},
  baseURL: '',
  users: [],
  assignableUsers: [],
  selectedFilters: {},
  tableSettings: {
    size: TABLE_SIZE.SM
  },
  tablePreferences: []
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case REDUCERS.USER.SET_USER_STATE: {
      return Object.assign({}, state, {
        ...state,
        ...action.value
      });
    }
    case REDUCERS.USER.SET_USER: {
      return Object.assign({}, state, {
        user: { ...action.value }
      });
    }
    case REDUCERS.USER.SET_BASE_URL: {
      return Object.assign({}, state, {
        baseURL: action.value
      });
    }
    case REDUCERS.USER.SET_USERS: {
      return Object.assign({}, state, {
        users: [...action.value]
      });
    }
    case REDUCERS.USER.SET_ASSIGNABLE_USERS: {
      return Object.assign({}, state, {
        assignableUsers: [...action.value]
      });
    }
    case REDUCERS.USER.SET_SELECTED_FILTERS: {
      return Object.assign({}, state, {
        selectedFilters: action.value
      });
    }
    case REDUCERS.USER.SET_TABLE_PREFERENCES: {
      return Object.assign({}, state, {
        tablePreferences: action.value
      });
    }
    case REDUCERS.USER.SET_TABLE_SETTINGS: {
      return Object.assign({}, state, {
        tableSettings: action.value
      });
    }
    case REDUCERS.USER.SET_USER_LOADING:
      return { ...state, loading: action.value };
    case REDUCERS.RESET:
      return initialState;
    default:
      return state;
  }
};

export { user };
